import {Field, FormikProvider, useFormik} from 'formik';
import {useTranslation} from 'react-i18next';

import {Grid, SxProps, Typography} from '@mui/material';

import {EmpionButton} from '../../../../../../../components/EmpionButton/EmpionButton';
import {EmpionTextField} from '../../../../../../../components/EmpionTextField/EmpionTextField';
import {empionGreen} from '../../../../../../../layouts/theme/EmpionColors';
import {Feedback} from '../../../../../../../lib/api/RequestBodies/features/company/Questionnaires/QuestionnaireRequestBodies';

interface Props {
  onSubmit: (answers?: Feedback[]) => void;
}

export default function OpenFeedback({onSubmit}: Props): JSX.Element {
  const {t} = useTranslation();
  const fieldStyles: SxProps = {
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'white',
      border: '1px solid #E0E0E0',
      '& fieldset': {
        borderColor: 'white',
      },
      '&:hover fieldset': {
        borderColor: 'white',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'white',
      },
      '& .MuiOutlinedInput-input': {
        color: empionGreen[900],
      },
    },
  };

  const formik = useFormik({
    initialValues: {
      positiveFeedback: '',
      negativeFeedback: '',
    },
    onSubmit: async (values) => {
      if (!values.negativeFeedback && !values.positiveFeedback) {
        onSubmit();
      } else {
        const payload: Feedback[] = [
          {
            feedbackType: 'positive',
            feedbackText: values.positiveFeedback,
          },
          {
            feedbackType: 'negative',
            feedbackText: values.negativeFeedback,
          },
        ];
        onSubmit(payload);
      }
    },
  });

  return (
    <Grid container justifyContent='center' alignItems='center' height='100vh'>
      <Grid item xs={12} sx={{textAlign: 'center'}}>
        <Typography
          variant='h1'
          gutterBottom
          textTransform={'uppercase'}
          sx={{
            fontSize: {xs: '3rem', sm: '3rem', md: '3rem', lg: '4.5rem'},
            lineHeight: {xs: '3.5rem', sm: '3rem', md: '3rem', lg: '4.5rem'},
          }}
        >
          {t('companySurveys.public.openFeedback.title')}
        </Typography>
        <Typography variant='h4'>{t('companySurveys.public.openFeedback.description')}</Typography>
      </Grid>
      <Grid container item xs={12} justifyContent='center' mt={4}>
        <FormikProvider value={formik}>
          <form onSubmit={formik.handleSubmit} style={{width: '100%'}}>
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '3rem',
              }}
            >
              <Field
                type='text'
                multiline
                rows={10}
                aria-label='positiveFeedback'
                name='positiveFeedback'
                placeholder={t('companySurveys.public.openFeedback.positivePlaceholder')}
                component={EmpionTextField}
                fullWidth
                sx={fieldStyles}
              />

              <Field
                type='text'
                multiline
                rows={10}
                aria-label='negativeFeedback'
                name='negativeFeedback'
                placeholder={t('companySurveys.public.openFeedback.negativePlaceholder')}
                component={EmpionTextField}
                fullWidth
                sx={fieldStyles}
              />
              <Grid item xs={12} sx={{textAlign: 'center', mb: {xs: 3}}}>
                <EmpionButton type='submit'>
                  <Typography variant='h4' sx={{color: 'white'}}>
                    {t('shared.formSubmit.submit')}
                  </Typography>
                </EmpionButton>
              </Grid>
            </Grid>
          </form>
        </FormikProvider>
      </Grid>
    </Grid>
  );
}
